import React from "react";
import { Card, Typography } from "@mui/material";
import { Page, Stack } from "components/layout/reusableLayouts";
import HubSpotForm from "../components/common/HubspotForm";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

interface SupportProps {
  company: string;
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
  subject: string;
  category: string;
  urgency: string;
}

const Support: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state as SupportProps | undefined; // Cast to DisputeProps for type safety

  const myInitialValues = {
    company: state?.company ?? "",
    email: state?.email ?? "",
    firstname: state?.firstname ?? "",
    lastname: state?.lastname ?? "",
    phone: state?.phone ?? "",
    "TICKET.subject": state?.subject ?? "Support issue",
    "TICKET.issue_category": state?.category ?? "Technical Support",
    "TICKET.urgency_level": state?.urgency ?? "Medium",
  };

  return (
    <Page>
      <Stack gap="var(--space-2)">
        <Typography variant="h2">{t("Support request")}</Typography>
        <Typography
          variant="body1"
          sx={{ color: "var(--color-text-secondary)" }}
        >
          {t("Provide information on the issue you are experiencing")}
        </Typography>
      </Stack>
      <Card
        variant="outlined"
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          padding: "var(--space-5)",
        }}
      >
        <HubSpotForm
          portalId="39988400"
          formId="32475fdd-38c8-4e38-9676-798c8f4fa889"
          initialValues={myInitialValues}
        />
      </Card>
    </Page>
  );
};

export default Support;
